'use client';
import React from 'react';
import { usePathname } from 'next/navigation';
import cn from '@utils/cn';
import Text, { TextVariant } from '@ui/Text/Text';
import { getLanguageHref } from '@utils/pathname';
import Checkmark from './icons/Checkmark';
import { LanguageType, LANGUAGES } from '@constants/languages';

type InternationalizationMenuProps = {
  isOpen: boolean;
  direction: 'up' | 'down';
  current: string;
};

export default function InternationalizationMenu({ isOpen, direction, current }: InternationalizationMenuProps) {
  const pathname = usePathname();

  if (!isOpen) {
    return null;
  }

  function renderLanguage(language: LanguageType) {
    const id = language.id;
    const href = getLanguageHref(pathname, id, true);
    const isCurrent = id === current;

    return (
      <a
        href={href}
        className={cn('group flex items-center gap-3 p-2', {
          'pointer-events-none': isCurrent,
        })}
        key={id}
      >
        <language.icon />
        <Text
          className="grow group-hover:underline"
          key={id}
          content={language.title}
          variant={TextVariant.TextBodySM}
        />
        {isCurrent && <Checkmark />}
      </a>
    );
  }

  const className = cn('absolute right-0 z-10 transform rounded-lg border border-black/10 bg-white ', {
    '-top-2 -translate-y-full': direction === 'up',
    '-bottom-2 translate-y-full': direction === 'down',
  });
  const style = {
    '--body-foreground': 'rgba(0, 0, 0, 0.87)',
  } as React.CSSProperties;

  return (
    <div className={className} style={style}>
      <div className="flex flex-col justify-center gap-2 p-4">{LANGUAGES.map(renderLanguage)}</div>
    </div>
  );
}
